module.exports = __webpack_public_path__ + "img/bm.4212fd54.png";